export default "__VITE_PUBLIC_ASSET__efb99589__"